import { ModalPropsForType } from 'containers/Modal/ModalPropsForType';
import { ModalType } from 'containers/Modal/ModalType';

// Types

type ShowModalAction<T extends ModalType = ModalType> = {
  type: 'MODAL_SHOW';
  payload: { type: T; props: ModalPropsForType<T> };
};

type HideModalAction = {
  type: 'MODAL_HIDE';
};

export type MainStoreModalAction = ShowModalAction | HideModalAction;

// Reducer

const initialState = {
  type: null,
  props: {},
};

export type MainStoreModalState = {
  type: ModalType | null | undefined;
  props: Record<string, unknown>;
};

export function modalReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreModalState = initialState,
  action: MainStoreModalAction,
) {
  switch (action.type) {
    case 'MODAL_SHOW':
      return {
        ...state,
        type: action.payload.type,
        props: action.payload.props,
      };

    case 'MODAL_HIDE':
      return initialState;

    default:
      return state;
  }
}

// Actions

export function showModal<T extends ModalType>(
  type: T,
  props: ModalPropsForType<T>,
): ShowModalAction {
  return {
    type: 'MODAL_SHOW',
    payload: { type, props },
  };
}

export function hideModal(): HideModalAction {
  return { type: 'MODAL_HIDE' };
}
